module.exports = __webpack_public_path__ + "735bf0092fa02660cd8abf5eea9bd1ab.svg";